import { render, staticRenderFns } from "./shaparak_referral.vue?vue&type=template&id=75072168"
import script from "./shaparak_referral.vue?vue&type=script&lang=js"
export * from "./shaparak_referral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports